import { render, staticRenderFns } from "./OnboardingMainInformationError.vue?vue&type=template&id=a9624574&"
import script from "./OnboardingMainInformationError.vue?vue&type=script&lang=js&"
export * from "./OnboardingMainInformationError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports